import { render, staticRenderFns } from "./RootCategory.vue?vue&type=template&id=3611915d&"
import script from "./RootCategory.vue?vue&type=script&lang=js&"
export * from "./RootCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports